// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sortable-column-header.asc .sort-caret.ascending[data-v-b2fd66da]{border-bottom-color:#409eff}.sortable-column-header.desc .sort-caret.descending[data-v-b2fd66da]{border-top-color:#409eff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
